import React from "react"
import { Skeleton } from "@/components/ui/skeleton"
import ServicesGridSkeleton from "@/components/services-grid-skeleton"

export default function ServicesPageSkeleton() {
  return (
    <div className="w-full  mx-auto px-4 md:pb-20 pt-2 font-sans">
      {/* Progress pill skeleton */}
      <div className="mb-6">
        <Skeleton className="w-full h-3 rounded-full" />
      </div>

      {/* Branch card skeleton */}
      <div className="rounded-3xl border border-border bg-white p-5 mb-6 shadow-sm flex flex-col items-center gap-4">
        <Skeleton className="w-12 h-12 rounded-full" />
        
        <div className="flex flex-col items-center gap-2 w-full">
          <Skeleton className="h-6 w-48 rounded-md" />
          <Skeleton className="h-4 w-32 rounded-md" />
        </div>

        <div className="flex gap-3 mt-2">
          <Skeleton className="h-8 w-64 rounded-full" />
        </div>
      </div>

      {/* Services container skeleton */}
      <div className="rounded-3xl bg-white shadow-sm border border-border p-5 md:p-6 min-h-[400px]">
        <div className="flex items-center justify-between mb-6">
          <Skeleton className="h-6 w-32 rounded-md" />
          <Skeleton className="w-10 h-10 rounded-full" />
        </div>

        <ServicesGridSkeleton />
      </div>

      {/* Back button skeleton */}
      <div className="flex justify-start mt-8">
        <Skeleton className="h-12 w-28 rounded-full" />
      </div>
    </div>
  )
}